<template>
	<div>
		<!-- <DrawerCollectionSettings ref="drawer_collection_settings" /> -->
		<base-header class="pb-6">
			<b-row align-v="center" class="py-3">
				<b-col lg="6" cols="7">
					<p class="text-muted">Credit Loan Case</p>
					<h2 class="text-xl d-inline-block mb-0">Collection</h2>
				</b-col>
				<!-- <b-col cols="6" class="text-right text-primary">
					<el-button type="primary" class="mr-4">View Report</el-button>
					<svg xmlns="http://www.w3.org/2000/svg" class="cursor-pointer"
						@click="$refs.drawer_collection_settings.show()" width="16" height="16"
						viewBox="0 0 512 512">
						<path fill="currentColor"
							d="M495.9 166.6c3.2 8.7.5 18.4-6.4 24.6l-43.3 39.4c1.1 8.3 1.7 16.8 1.7 25.4s-.6 17.1-1.7 25.4l43.3 39.4c6.9 6.2 9.6 15.9 6.4 24.6-4.4 11.9-9.7 23.3-15.8 34.3l-4.7 8.1c-6.6 11-14 21.4-22.1 31.2-5.9 7.2-15.7 9.6-24.5 6.8l-55.7-17.7c-13.4 10.3-28.2 18.9-44 25.4l-12.5 57.1c-2 9.1-9 16.3-18.2 17.8-13.8 2.3-28 3.5-42.5 3.5s-28.7-1.2-42.5-3.5c-9.2-1.5-16.2-8.7-18.2-17.8l-12.5-57.1c-15.8-6.5-30.6-15.1-44-25.4l-55.6 17.8c-8.8 2.8-18.6.3-24.5-6.8-8.1-9.8-15.5-20.2-22.1-31.2l-4.7-8.1c-6.1-11-11.4-22.4-15.8-34.3-3.2-8.7-.5-18.4 6.4-24.6l43.3-39.4c-1.1-8.4-1.7-16.9-1.7-25.5s.6-17.1 1.7-25.4l-43.3-39.4c-6.9-6.2-9.6-15.9-6.4-24.6 4.4-11.9 9.7-23.3 15.8-34.3l4.7-8.1c6.6-11 14-21.4 22.1-31.2 5.9-7.2 15.7-9.6 24.5-6.8l55.7 17.7c13.4-10.3 28.2-18.9 44-25.4l12.5-57.1c2-9.1 9-16.3 18.2-17.8C227.3 1.2 241.5 0 256 0s28.7 1.2 42.5 3.5c9.2 1.5 16.2 8.7 18.2 17.8l12.5 57.1c15.8 6.5 30.6 15.1 44 25.4l55.7-17.7c8.8-2.8 18.6-.3 24.5 6.8 8.1 9.8 15.5 20.2 22.1 31.2l4.7 8.1c6.1 11 11.4 22.4 15.8 34.3zM256 336a80 80 0 1 0 0-160 80 80 0 1 0 0 160z" />
					</svg>
				</b-col> -->
			</b-row>
		</base-header>
		<b-container fluid class="mt--6">
			<CollectionTable />
		</b-container>
	</div>
</template>
<script>
import { Button } from 'element-ui'
// import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb'
import CollectionTable from '@/views/CreditLoanCollection/CollectionTable'
// import DrawerCollectionSettings from '@/views/CreditLoanCollection/Drawers/DrawerCollectionSettings'

export default {
	components: {
		// RouteBreadCrumb,
		CollectionTable,
		// DrawerCollectionSettings,
		[Button.name]: Button,
	},
	data() {
		return {
			backButton: false,
			isTableLoading: true,
		}
	}
}
</script>